// user-agent判定
var ua = navigator.userAgent;
//iPhone向けの処理
if (ua.indexOf('iPhone') > 0) {
	$(function() {
		$('.download-link').addClass('js-device-iphone');
	});
}